<script setup>
import CheckboxCustomButton from "../../base/checkbox-cutom-button/index.vue";
import { computed } from "vue";

const props = defineProps({
  modelValue: Array,
});
const emits = defineEmits(["update:modelValue"]);

const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});
// "ลักษณะของครัวเรือน
// HHT1 : อยู่คนเดียว
// HHT2 : ครัวเรือนเดี่ยว (พ่อ แม่ ลูก)
// HHT3 : ครัวเรือนขยาย (พ่อ แม่ ลูก พี่ น้อง ปู่ ย่า ตา ยาย หลาน)
// ตัวอย่าง
// {
//     ""code"": ""HHT3"",
//     ""desc"": ""ครัวเรือนขยาย""
// }"
</script>

<template>
  <section data-test="filter-household-characteristics">
    <div class="mt-3">
      <h4 class="text-base font-normal leading-none text-theme-33">
        ลักษณะครัวเรือน
      </h4>
    </div>

    <div class="flex flex-wrap mt-2">
      <CheckboxCustomButton
        id="alone-checkbox"
        :value="{ code: 'HHT1', desc: 'อยู่คนเดียว' }"
        text="อยู่คนเดียว"
        class="mx-1 my-1"
        v-model="modelValueComputed"
      />
      <CheckboxCustomButton
        id="one-household-checkbox"
        :value="{ code: 'HHT2', desc: 'ครัวเรือนเดี่ยว' }"
        text="ครัวเรือนเดี่ยว"
        class="mx-1 my-1"
        v-model="modelValueComputed"
      />
      <CheckboxCustomButton
        id="growing-household-checkbox"
        :value="{ code: 'HHT3', desc: 'ครัวเรือนขยาย' }"
        text="ครัวเรือนขยาย"
        class="mx-1 my-1"
        v-model="modelValueComputed"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
input[type="checkbox"] {
  display: none;
}
</style>
